export const updateGRNPayloadMapper = (
  poDetails,
  grnItems,
  attachments,
  invoiceUrls,
  formDetails,
  grnExtraCharges = []
) => {
  const { id } = poDetails;
  let payload = {
    purchaseOrderId: +id,
    inwardDate: new Date().toISOString(),
    invoiceDate: formDetails.invoiceDate,
    financialyear: formDetails.financialyear,
    invoiceNumber: formDetails.invoiceNumber,
    invoiceAmount: formDetails.invoiceAmount,
    receivedItems: grnItems
      .filter((i) => i.receivedQuantity && i.receivedQuantity != 0)
      .map((item) => {
        return {
          poItemId: item.poItemId,
          receivedQuantity: item.receivedQuantity || 0,
          comments: item.comments || "",
          hsnCode: item?.hsnCode != undefined ? item.hsnCode : "",
        };
      }),
  };
  const receivedExtraCharges = (grnExtraCharges || [])
    .filter((c) => c.receivedQuantity && c.receivedQuantity != 0)
    .map((charge) => ({
      poExtraChargeId: charge.poExtraChargeId,
      receivedQuantity: charge.receivedQuantity || 0,
      comments: charge.comments || "",
    }));
  if (receivedExtraCharges.length > 0) {
    payload.receivedExtraCharges = receivedExtraCharges;
  }

    payload.additionalDocUrls = attachments.map((a) => a.docUrl);
    payload.invoiceUrls = invoiceUrls.map((a) => a.docUrl);

  if (formDetails.remarks) {
    payload.remarks = formDetails.remarks;
  }
  if (formDetails?.msmeDeclaration) {
    payload.msmeDeclaration = formDetails.msmeDeclaration;
  }
  if (formDetails.inwardDate) {
    payload.inwardDate = formDetails.inwardDate;
  }

  return payload;
};
